import { IconNames } from '@blueprintjs/icons';
import { TextWithIcon } from '@strata/react-status-icons';

interface PayerRequestNumberProps {
    text: string;
    pbmOnly?: boolean;
}

export const PayerRequestNumber = ({ text, pbmOnly = false }: PayerRequestNumberProps) => (
    <TextWithIcon
        text={text}
        icon={pbmOnly ? IconNames.SHIELD : undefined}
        tooltipContent={
            <>
                <div>{text}</div>
                {pbmOnly ? <div>PBM Only</div> : null}
            </>
        }
    />
);
